import productPills from "../../../assets/img/product-gg-1-pills.png"
import productPillsWebp from "../../../assets/img/product-gg-1-pills.webp"

const TooMuch = () => (
    <section id="too-much">
        <div className="container-fluid py-2 text-center gg-bg-solid-gray">
            <div className="row align-items-center justify-content-center">
                <div className="col-xxl-4 col-lg-5 col-md-6 col-12 mt-md-0 mt-1 align-items-center text-center">
                    <picture>
                        <source srcSet={productPillsWebp} type="image/webp" />
                        <img className="img-fluid gg-border-radius" src={productPills} loading="lazy" />
                    </picture>
                </div>
                <div className="offset-lg-1 col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center">
                    <h3 className="mb-4"><b>Was that too much?</b></h3>
                    <p className="fw-light mb-3">Totally understandable.</p>
                    <p className="fw-light mb-3">Daniel hesitated too.<br />He wasn’t sure if this was just another promise in a bottle.<br />So, he started with one.</p>
                    <p className="fw-light mb-3">But here’s what he didn’t expect:</p>
                    <h5 className="">By the time he was nearing the end of that first bottle, the anxiety hit hard. </h5>
                </div>
            </div>
        </div>
    </section>
);

export default TooMuch;